module.exports = __webpack_public_path__ + "img/gift.b376d7d1.svg";